var React = require('react');

function Calculator (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"icon","d":"M45.024,0H33a1,1,0,0,0-1,1V15.028a1,1,0,0,0,1,1H45.024a1,1,0,0,0,1-1V1A1,1,0,0,0,45.024,0ZM36.008,14.026H34v-2h2Zm0-4.008H34v-2h2Zm4.008,4.008h-2v-2h2Zm0-4.008h-2v-2h2Zm4.008,4.008h-2V8.015h2Zm0-8.516a.5.5,0,0,1-.5.5H34.5a.5.5,0,0,1-.5-.5V2.5a.5.5,0,0,1,.5-.5h9.017a.5.5,0,0,1,.5.5Z","transform":"translate(-32)"}));
}

Calculator.defaultProps = {"viewBox":"0 0 14.026 16.03"};

module.exports = Calculator;

Calculator.default = Calculator;
